import './App.css';
import { Routes, Route } from 'react-router-dom';
import { ChangePasswordPage } from './gym/auth/ChangePasswordPage';
import { RoleRoute } from './gym/auth/RoleRoute';
import { RoleHomeRedirect } from './gym/auth/RoleHomeRedirect';
import { EntryRoute, PasswordChangeRoute } from './gym/auth/SessionRoutes';
import { AppShell } from './gym/layout/AppShell';
import { AdminDashboard } from './gym/admin/AdminDashboard';
import { PlansPage } from './gym/admin/PlansPage';
import { MembersPage } from './gym/admin/MembersPage';
import { MemberDetailPage } from './gym/admin/MemberDetailPage';
import { PaymentsPage } from './gym/admin/PaymentsPage';
import { CoachesPage } from './gym/admin/CoachesPage';
import { SettingsPage } from './gym/admin/SettingsPage';
import { KiosksPage } from './gym/admin/KiosksPage';
import { CheckinsPage } from './gym/admin/CheckinsPage';
import { OperationsReportPage } from './gym/admin/OperationsReportPage';
import { ImportMembersPage } from './gym/admin/import/ImportMembersPage';
import { ImportPaymentHistoryPage } from './gym/admin/import/ImportPaymentHistoryPage';
import { MemberHomePage } from './gym/member/MemberHomePage';
import { MemberMembershipsPage } from './gym/member/MemberMembershipsPage';
import { MemberProfilePage } from './gym/member/MemberProfilePage';
import { MyRoutinePage } from './gym/member/MyRoutinePage';
import { TrainPage } from './gym/member/TrainPage';
import { ProgressPage } from './gym/member/ProgressPage';
import { CoachHomePage } from './gym/coach/CoachHomePage';
import { CoachMemberPage } from './gym/coach/CoachMemberPage';
import { ExercisesPage } from './gym/admin/ExercisesPage';
import { UpdateBanner } from './gym/pwa/UpdateBanner';
import { OfflineNotice } from './gym/pwa/OfflineNotice';
import { KioskPage } from './gym/kiosk/KioskPage';

import { FeedPage } from './gym/community/FeedPage';
import { PostDetailPage } from './gym/community/PostDetailPage';
import { ProfilePage } from './gym/community/ProfilePage';
import { ReportsPage } from './gym/admin/community/ReportsPage';
import { useAuth } from './gym/auth/AuthContext';

function CommunityShell() {
  const { user } = useAuth();
  return <AppShell role={user.role} />;
}

/**
 * Definitive route tree for phase 1B (spec "Navegación y experiencia").
 * `/` is only the login (or the redirect of an existing session); each role
 * tree lives inside its own shell behind `RoleRoute`; anything else goes to
 * the role's home. Every route now renders its real page (Task 6's
 * placeholder `PageState` screens were replaced one by one through Tasks
 * 7–12; each page keeps using `PageState` itself for its own loading/error
 * states).
 */
function App() {
  return (
    <>
      <UpdateBanner />
      <OfflineNotice />
      <Routes>
        <Route path="/" element={<EntryRoute />} />
        <Route
          path="/cambiar-password"
          element={<PasswordChangeRoute><ChangePasswordPage /></PasswordChangeRoute>}
        />
        <Route path="/kiosco" element={<RoleRoute roles={['admin', 'kiosk']}><KioskPage /></RoleRoute>} />
        <Route element={<RoleRoute roles={['admin', 'coach', 'user']}><CommunityShell /></RoleRoute>}>
          <Route path="/comunidad" element={<FeedPage />} />
          <Route path="/comunidad/publicacion/:postId" element={<PostDetailPage />} />
          <Route path="/comunidad/perfil/:userId" element={<ProfilePage />} />
        </Route>
        <Route element={<RoleRoute roles={['admin']}><AppShell role="admin" /></RoleRoute>}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/socios" element={<MembersPage />} />
          <Route path="/admin/socios/importar" element={<ImportMembersPage />} />
          <Route path="/admin/socios/importar-pagos" element={<ImportPaymentHistoryPage />} />
          <Route path="/admin/socios/:id" element={<MemberDetailPage />} />
          <Route path="/admin/pagos" element={<PaymentsPage />} />
          <Route path="/admin/planes" element={<PlansPage />} />
          <Route path="/admin/profesores" element={<CoachesPage />} />
          <Route path="/admin/ejercicios" element={<ExercisesPage />} />
          <Route path="/admin/comunidad/denuncias" element={<ReportsPage />} />
          <Route path="/admin/configuracion" element={<SettingsPage />} />
          <Route path="/admin/ingresos" element={<CheckinsPage />} />
          <Route path="/admin/kioscos" element={<KiosksPage />} />
          <Route path="/admin/reportes" element={<OperationsReportPage />} />
        </Route>
        <Route element={<RoleRoute roles={['user']}><AppShell role="user" /></RoleRoute>}>
          <Route path="/mi-cuenta" element={<MemberHomePage />} />
          <Route path="/mi-cuenta/rutina" element={<MyRoutinePage />} />
          <Route path="/mi-cuenta/entrenar" element={<TrainPage />} />
          <Route path="/mi-cuenta/progreso" element={<ProgressPage />} />
          <Route path="/mi-cuenta/cuota" element={<MemberMembershipsPage />} />
          <Route path="/mi-cuenta/perfil" element={<MemberProfilePage />} />
        </Route>
        <Route element={<RoleRoute roles={['coach']}><AppShell role="coach" /></RoleRoute>}>
          <Route path="/coach" element={<CoachHomePage />} />
          <Route path="/coach/socios/:id" element={<CoachMemberPage />} />
          <Route path="/coach/ejercicios" element={<ExercisesPage />} />
        </Route>
        <Route path="*" element={<RoleHomeRedirect />} />
      </Routes>
    </>
  );
}

export default App;
